<template>
  <div
    id="notification_badge"
    :class="{
      'left-16': $i18n.locale == 'fa',
      'right-16': $i18n.locale != 'fa',
    }"
    class="flex flex-row-reverse gap-4"
  >
    <el-badge :value="notifCount" :max="99" class="item">
      <i
        class="el-icon-message-solid text-2xl text-gray-600 cursor-pointer"
        @click="OpenNotificationDrawer"
      ></i>
    </el-badge>
    <!-- <ChangeLanguage :showTitle="false" /> -->
    <DropDown :title="$t('ADD')" class="flex items-center">
      <template v-slot:button>
        <i class="el-icon-plus text-2xl text-gray-600 cursor-pointer"></i>
      </template>
      <template v-slot:content>
        <router-link
          v-for="(item, index) in menu"
          @click.native="$emit('link-click')"
          :key="index"
          class="
            whitespace-nowrap
            text-xs
            font-medium
            text-gray-600
            hover:text-carpo
          "
          :to="{ name: item.title }"
        >
          {{ $t(item.title) }}
        </router-link>
      </template>
    </DropDown>

    <DropDown :title="$t('user_management')" class="flex items-center">
      <template v-slot:button>
        <i class="el-icon-s-custom text-2xl text-gray-600 cursor-pointer"></i>
      </template>
      <template v-slot:content>
        <router-link
          @click.native="$emit('link-click')"
          v-for="(item, index) in userManagement"
          :key="index"
          class="
            whitespace-nowrap
            text-xs
            font-medium
            text-gray-600
            hover:text-carpo
          "
          :to="{ name: item.title }"
        >
          {{ $t(item.title) }}
        </router-link>
      </template>
    </DropDown>

    <NotificationDrawer />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChangeLanguage from '@/components/setting/ChangeLanguage.vue'
import NotificationDrawer from '@/components/Notification/NotificationDrawer.vue'
import DropDown from '@/components/elements/dropDown.vue'
export default {
  components: {
    NotificationDrawer,
    ChangeLanguage,
    DropDown,
  },
  methods: {
    OpenNotificationDrawer() {
      this.$store.commit('OPEN_DRAWER', true)
    },
  },
  computed: {
    ...mapGetters(['notifCount', 'navbar']),
  },
  data() {
    return {
      menu: [
        {
          title: 'ADD_DRIVER',
        },
        {
          title: 'ADD_VEHICLE',
        },
        {
          title: 'ADD_FUEL',
        },
        {
          title: 'ADD_FINES',
        },
      ],
      userManagement: [
        {
          title: 'ADD_ORGANIZATION',
        },
        {
          title: 'ADD_USER',
        },
        {
          title: 'ORGANIZATION_LIST',
        },
        {
          title: 'USERS_LIST',
        },
      ],
    }
  },
}
</script>
<style>
#notification_badge {
  position: absolute;
}
</style>
